import { useEffect, useState, useMemo, useCallback, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { CLICK, ENTER } from './constants'

export const useModal = (options = {}) => {
  const { searchKey, searchValue } = options
  const [showModal, setShowModal] = useState(false)
  const modalOpenedRef = useRef(false)
  const history = useHistory()
  const location = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ])

  const updateUrl = useCallback(
    shouldAdd => {
      if (searchKey) {
        if (shouldAdd) {
          searchParams.set(searchKey, searchValue)
        } else {
          searchParams.delete(searchKey)
        }
        history.replace({ search: searchParams.toString() })
      }
    },
    [searchKey, searchValue, searchParams, history],
  )

  const openModal = useCallback(() => {
    if (showModal) {
      return
    }
    updateUrl(true)
    setShowModal(true)
    modalOpenedRef.current = true
  }, [showModal, updateUrl])

  const closeModal = useCallback(() => {
    updateUrl(false)
    setShowModal(false)
    modalOpenedRef.current = false
  }, [updateUrl])

  const createOpenHandler = useCallback(
    event => {
      if (event.type === CLICK || event.key === ENTER) {
        openModal()
      }
    },
    [openModal],
  )

  // Effect specifically used for url search key tracking
  useEffect(() => {
    if (modalOpenedRef.current) {
      return
    }

    const urlSearchValue = searchParams.get(searchKey)
    if (searchKey && urlSearchValue === searchValue && !showModal) {
      setShowModal(true)
      modalOpenedRef.current = true
    }
  }, [searchParams, searchKey, searchValue, showModal])

  return {
    showModal,
    openModal,
    closeModal,
    createOpenHandler,
  }
}
